import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { leagueRepository } from "@/config/dataSource";

export const leaguesQueryKeys = {
  all: ["leagues"] as const,
  detail: (leagueId: string) => ["leagues", leagueId] as const,
};

/** Ligas do usuário logado — alimenta Home e "Minhas Ligas". */
export function useLeagues() {
  return useQuery({
    queryKey: leaguesQueryKeys.all,
    queryFn: () => leagueRepository.getMyLeagues(),
  });
}

/** Excluir liga (pedido do usuário) — ação destrutiva, só admin. */
export function useDeleteLeague() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (leagueId: string) => leagueRepository.deleteLeague(leagueId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: leaguesQueryKeys.all }),
  });
}
